import { defineKey as T } from 'ha/i18n';

export const STATE_NAME = 'profileEdit';

export enum ProfileSectionsValues {
  PERSONAL_INFORMATION = 'personal_information',
  SUPPORTING_DOCUMENTS = 'supporting_documents',
  CONTACT_INFORMATION = 'contact_information',
  CHANGE_PASSWORD = 'change_password',
  NOTIFICATION_SETTINGS = 'notification_settings',
}

/**
 * @description use the useSectionNames hook instead of calling this const directly
 */
export const ProfileSectionsNames = {
  [ProfileSectionsValues.PERSONAL_INFORMATION]: T(
    'editProfile.Personal_navmenu',
  ),
  [ProfileSectionsValues.SUPPORTING_DOCUMENTS]: {
    advertiser: T('editProfile.DocumentsAdvertiser_navmenu'),
    tenant: T('editProfile.DocumentsTenants_navmenu'),
  },
  [ProfileSectionsValues.CONTACT_INFORMATION]: T('editProfile.Contact_navmenu'),
  [ProfileSectionsValues.CHANGE_PASSWORD]: T('editProfile.Password_navmenu'),
  [ProfileSectionsValues.NOTIFICATION_SETTINGS]: T(
    'editProfile.Notifications_navmenu',
  ),
};
